import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Modal, Image } from "semantic-ui-react";

@observer
class ImageViewer extends Component {
  render() {
    const { open, size = null, title, url, onClose } = this.props;

    return (
      <Modal size={size} basic open={open} onClose={() => onClose && onClose()}>
        <Modal.Header>{title}</Modal.Header>
        <Modal.Content>
          <Image wrapped fluid rounded src={url} />
        </Modal.Content>
      </Modal>
    );
  }
}

ImageViewer.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.node,
  url: PropTypes.string,
  size: PropTypes.oneOf(["mini", "tiny", "small", "large", "fullscreen"]),
  onClose: PropTypes.func,
};

export default ImageViewer;
